export const AMBASSADOR_ADVANTAGES_KEYS = [
  'advantage1',
  'advantage2',
  'advantage3',
  'advantage4',
  'advantage5',
  'advantage6',
] as const;

export const AMBASSADOR_MISSION_KEYS = ['concrete1', 'concrete2', 'concrete3', 'concrete4', 'concrete5'] as const;
